import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { Button, Modal } from 'antd';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle} from "@fortawesome/free-solid-svg-icons";

const Parser = require('html-to-react').Parser;

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem }

export const ConfirmEmailModal =

withRouter(

  // redux
  connect(
    (null), 
    (mapDispatchToProps)
  )(

  class extends Component {

    constructor(props){
      super(props);
      this.state = {
        codigoVerificacaoEmail: '',
        codigoNaoPreenchido: false,
      }

      this.cancelar = this.cancelar.bind(this);
      this.confirmar = this.confirmar.bind(this);
      this.reenviar = this.reenviar.bind(this);
    }

    render() {
      return <Modal
              title={<Fragment>
                        <FontAwesomeIcon icon={faExclamationCircle} size="2x" style={{color: "#FFCD07"}}/> {this.props.titulo}
                      </Fragment>
                    }
            open={this.props.visible}
            maskClosable = {false}
            width={this.props.width ? this.props.width : 400}
            onCancel={this.cancelar}
            onOk={this.props.handleOk}
            footer={[
              <Button  onClick={this.reenviar}>{this.props.reenviarText ? this.props.reenviarText : 'Reenviar'}</Button>,
              <Button onClick={this.cancelar}>{this.props.cancelText ? this.props.cancelText : 'Cancelar'}</Button>,
              <Button type="primary" onClick={(e) => this.confirmar(e)} disable={this.state.codigoVerificacaoEmail.length !== 6}>{this.props.okText ? this.props.okText : 'OK'} </Button>,
                    ]}

            centered
          >
            <p>{Parser().parse(this.props.message)}</p>

            <div className="br-form">
                <div className="row">
                  <div className="col-md">
                    <div className="field">
                      <div className="input">
                        <label htmlFor="codigoVerificacaoEmail">Código de verificação:</label>
                        <input type="text" name="codigoVerificacaoEmail" maxLength="6"
                          value={this.state.codigoVerificacaoEmail}
                          onChange={(e) => this.setState({codigoVerificacaoEmail: e.target.value})}
                          />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </Modal>
    }

    cancelar() {
      this.props.handleCancel();
      this.setState({codigoVerificacaoEmail: ''})
    }

    confirmar(e) {
      const codigoVerificacaoEmail = this.state.codigoVerificacaoEmail;

      if(!codigoVerificacaoEmail){
          this.setState({codigoNaoPreenchido: true})
				  return;
      }

      this.props.handleOk(e, codigoVerificacaoEmail);
      this.setState({codigoVerificacaoEmail: ''})
    }

    reenviar() {
      this.props.handleReenviar();
      this.setState({codigoVerificacaoEmail: ''})
    }

  }) // redux
); // router